<template>
  <div>
    <DropdownContainer ref="dropdownContainerShareAdForm" :modal-size="'large'">
      <div class="share-ad-form">
        <div class="share-ad-form__content">
          <div class="share-ad-form__header share-ad-form__push-bottom">
            Del denne annonce
          </div>

          <div v-if="adVariantInfo" class="share-ad-form__company-info">
            <div v-if="adVariantInfo.makeModel">
              <label>
                <strong>{{ adVariantInfo.makeModel }}</strong>
              </label>
            </div>
            <div v-if="adVariantInfo.variant">
              <label>{{ adVariantInfo.variant }}</label>
            </div>
            <div v-if="adVariantInfo.generalInfo">
              <label>{{ adVariantInfo.generalInfo }}</label>
            </div>
          </div>

          <div class="share-ad-form__facebook-button-container">
            <button
              @click.prevent="shareAd()"
              class="share-ad-form__facebook-share button button--invert button--blue-border"
            >
              Del på facebook
            </button>
          </div>

          <div class="share-ad-form__subheader">
            Del annoncen via email eller sms
          </div>
          <div class="share-ad-form__push-bottom">
            <p class="error my-1" v-if="senderNameErrorMessage">
              <span>{{ senderNameErrorMessage }}</span>
              <span class="error__attention"></span>
            </p>
            <div class="input-container">
              <input
                class="error--input form-control"
                title="Navn"
                type="text"
                id="input_share-ad-form_name"
                placeholder="Skriv dit navn her"
                v-model="senderName"
              />
              <label class="control-label" for="input_share-ad-form_name">
                Dit navn
              </label>
            </div>
          </div>

          <div class="share-ad-form__push-bottom">
            <p class="error my-1" v-if="receiverEmailErrorMessage">
              <span>{{ receiverEmailErrorMessage }}</span>
              <span class="error__attention"></span>
            </p>
            <div class="input-container">
              <input
                class="form-control"
                title="Email"
                type="text"
                id="input_share-ad-form_email"
                placeholder="Del via email, skriv email til modtager her"
                v-model="receiverEmail"
              />
              <label class="control-label" for="input_share-ad-form_email">
                Del via email
              </label>
            </div>
          </div>

          <div class="share-ad-form__push-bottom--light">
            <p class="error my-1" v-if="senderMessageErrorMessage">
              <span>{{ senderMessageErrorMessage }}</span>
              <span class="error__attention"></span>
            </p>
            <div class="input-container">
              <textarea
                class="share-ad-form__description form-control"
                title="Besked"
                type="text"
                id="input_share-ad-form_text"
                placeholder="Skriv din besked her (medsendes kun på mail)"
                v-model="senderMessage"
              />
              <label class="control-label" for="input_share-ad-form_text">
                Din besked (medsendes kun på email)
              </label>
            </div>
          </div>

          <div class="share-ad-form__push-bottom">
            <p class="error my-1" v-if="receiverPhoneErrorMessage">
              <span>{{ receiverPhoneErrorMessage }}</span>
              <span class="error__attention"></span>
            </p>
            <div class="input-container">
              <input
                class="form-control"
                title="Telefonnummer"
                type="text"
                id="input_share-ad-form_phone"
                placeholder="Del via sms, skriv telefonnummeret til modtager her"
                v-model="receiverPhone"
              />
              <label class="control-label" for="input_share-ad-form_phone">
                Del via sms
              </label>
            </div>
          </div>

          <div class="contact-form__recaptcha">
            <p class="error my-1" v-if="recaptchaErrorMessage">
              <span>{{ recaptchaErrorMessage }}</span>
              <span class="error__attention"></span>
            </p>
            <div data-callback="recaptchaCallback" ref="recaptcha"></div>
          </div>

          <div class="share-ad-form__button-container">
            <button class="button button--invert" @click.prevent="closeForm()">
              Luk
            </button>
            <button
              class="button button--highlight button--invert-disabled"
              :disabled="!requirementsFulfilled || inProgress"
              @click.prevent="sendForm()"
            >
              Send
              <ButtonSpinner v-if="inProgress" />
            </button>
          </div>
        </div>
      </div>
    </DropdownContainer>
  </div>
</template>

<script>
import { app } from '@/main'
import { nextTick } from 'vue'

import DropdownContainer from '@shared/DropdownContainer/DropdownContainer.vue'
import ButtonSpinner from '@components/Shared/ButtonSpinner/ButtonSpinner.vue'

import UidMixin from '@shared/uid-mixin.vue'

import { LogCriteoAddToCart } from '@/events'
import { shareOnFacebook } from '@/functions'

export default {
  mixins: [UidMixin],
  components: {
    DropdownContainer,
    ButtonSpinner,
  },
  props: {
    adId: { default: 0, type: Number },
    name: { default: '', type: String },
    adVariantInfo: { default: null, type: Object },
    recaptchaSitekey: { default: '', type: String },
  },
  data() {
    return {
      uid: null,
      senderName: '',
      receiverEmail: '',
      receiverPhone: '',
      senderMessage: '',

      errorHappened: false,
      errorMissingReceiver: false,
      senderNameErrorMessage: '',
      receiverEmailErrorMessage: '',
      receiverPhoneErrorMessage: '',
      senderMessageErrorMessage: '',

      recaptchaErrorMessage: '',

      requirementsFulfilled: false,
      inProgress: false,

      recaptchaRendered: false,
      recaptchaIndex: undefined,
    }
  },
  methods: {
    init() {
      this.clearData()
    },
    clearData() {
      this.senderName = this.name
      this.receiverEmail = ''
      this.receiverPhone = ''
      this.senderMessage = ''
      this.clearErrorMessages()
    },
    closeForm() {
      this.clearData()

      this.$refs.dropdownContainerShareAdForm.close()

      window.grecaptcha.reset(this.recaptchaIndex)
    },
    openForm() {
      this.$refs.dropdownContainerShareAdForm.open()

      this.$nextTick(() => {
        if (window.grecaptcha !== undefined && !this.recaptchaRendered) {
          this.recaptchaIndex = window.grecaptcha.render(this.$refs.recaptcha, {
            sitekey: this.recaptchaSitekey,
          })
          this.recaptchaRendered = true
        }
      })
    },
    clearErrorMessages() {
      this.errorHappened = false
      this.errorMissingReceiver = false
      this.senderNameErrorMessage = ''
      this.receiverEmailErrorMessage = ''
      this.receiverPhoneErrorMessage = ''
      this.senderMessageErrorMessage = ''
      this.recaptchaErrorMessage = ''
      this.recaptchaRendered = false
    },
    recaptchaCallback() {
      this.recaptchaErrorMessage = ''
    },
    formValidation() {
      this.clearErrorMessages()

      if (
        this.isNullOrEmpty(this.receiverEmail) &&
        this.isNullOrEmpty(this.receiverPhone)
      ) {
        this.errorHappened = true
        this.errorMissingReceiver = true
        this.receiverEmailErrorMessage = 'Angiv mindst én kontaktform'
        this.receiverPhoneErrorMessage = 'Angiv mindst én kontaktform'
      }

      if (this.isNullOrEmpty(this.senderName)) {
        this.errorHappened = true
        this.senderNameErrorMessage = 'Angiv venligst dit navn'
      }

      if (window.grecaptcha.getResponse(this.recaptchaIndex) === '') {
        this.recaptchaErrorMessage = 'Du skal bevise at du ikke er en robot'
        this.errorHappened = true
      }
    },
    shareAd() {
      const url = window.location.pathname
      shareOnFacebook(url)
    },
    sendForm() {
      this.inProgress = true
      this.formValidation()

      if (this.errorHappened) {
        this.inProgress = false
        window.grecaptcha.reset(this.recaptchaIndex)
        return
      }

      const url = '/api/Message/SendMessageShareAd'

      const owner = this
      // AXIOS to server
      app.axios
        .post(window.location.origin + url, {
          adId: this.adId,
          name: this.senderName,
          email: this.receiverEmail,
          phone: this.receiverPhone,
          message: this.senderMessage,
          recaptcha: window.grecaptcha.getResponse(this.recaptchaIndex),
        })
        .then(resp => {
          if (
            resp.data.errorCollection &&
            resp.data.errorCollection.length > 0
          ) {
            resp.data.errorCollection.forEach(value => {
              switch (value.errorItem.toLowerCase()) {
                case 'email':
                  owner.receiverEmailErrorMessage = value.errorMessage
                  break
                case 'phone':
                  owner.receiverPhoneErrorMessage = value.errorMessage
                  break
                case 'recaptcha':
                  owner.recaptchaErrorMessage = value.errorMessage
                  break
                default:
                  app.toast.error(value.errorMessage)
              }
            })
          } else {
            owner.closeForm()
            const successMessage = 'Annoncen er delt'

            nextTick(() => {
              app.toast.success(successMessage)
              LogCriteoAddToCart(owner.adId)
            })
          }
          this.inProgress = false
          window.grecaptcha.reset(this.recaptchaIndex)
        })
    },
    contactFormSelectionCallback() {
      this.clearErrorMessages()
    },
    isNullOrEmpty(str) {
      if (str === null) return true
      if (typeof str === 'undefined') return true
      if (str === '') return true
      if (str.trim() === '') return true
      return false
    },
    validateRequirements() {
      if (
        !this.isNullOrEmpty(this.senderName) &&
        (!this.isNullOrEmpty(this.receiverEmail) ||
          !this.isNullOrEmpty(this.receiverPhone))
      ) {
        this.requirementsFulfilled = true
      } else {
        this.requirementsFulfilled = false
      }
    },
  },
  watch: {
    senderName() {
      this.senderMessageErrorMessage = ''
      this.validateRequirements()
    },
    receiverEmail() {
      this.receiverEmailErrorMessage = ''
      if (this.errorMissingReceiver) {
        this.receiverPhoneErrorMessage = ''
      }
      this.validateRequirements()
    },
    receiverPhone() {
      this.receiverPhoneErrorMessage = ''
      if (this.errorMissingReceiver) {
        this.receiverEmailErrorMessage = ''
      }
      this.validateRequirements()
    },
  },
  created() {
    window.recaptchaCallback = this.recaptchaCallback

    this.init()
  },
}
</script>

<style lang="scss">
@import 'ShareAdForm.scss';
</style>
